module.exports = __webpack_public_path__ + "img/icon98.7cd538df.png";